export class HelpContextualInfo {
  title?: string;
  description?: string;
  route?: string;
  element?: string;

  public static MockOne(
    title = 'Widgets',
    description = 'Här har vi widgets',
    route = 'Klicka här',
    element = 'goto place'
  ) {
    return { title, description, route, element } as HelpContextualInfo;
  }

  public static MockMany() {
    return [
      HelpContextualInfo.MockOne('Widgets', 'Här har vi widgets', 'Klicka här', 'goto place'),
      HelpContextualInfo.MockOne(
        'Stapeldiagram över energiförbrukning',
        'Här har vi widgets',
        'Klicka här',
        'goto place'
      )
    ];
  }
}
